<div class="slider {{ class }}">
	<owl-carousel #owlElement [options]="{dots: false, navigation: false, loop: true, autoWidth: true}" [items]="slides" [carouselClasses]="['owl-theme', 'row', 'sliding']">
		<img *ngFor="let slide of slides" src="{{ (environment.webUrl !== '' && environment.expoBuild === false ? environment.webUrl : (environment.webUrl === '' && environment.expoBuild === false ? cordova?.file.dataDirectory : '')) + slide }}" />
	</owl-carousel>
	<div class="slider__btn-slide slider__btn-slide--left" (tap)="onPrev()"><i class="fa fa-angle-left slider__icon slider__icon--left"></i></div>
	<div class="slider__btn-slide slider__btn-slide--right" (tap)="onNext()"><i class="fa fa-angle-right slider__icon slider__icon--right"></i></div>
</div>


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/slider/slider.component.html